import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";

// Import all page components
import AttendanceTracking from "./pages/attendance-tracking";
import LeaveManagement from "./pages/leave-management";
import EmployeeDashboard from "./pages/employee-dashboard";
import AdminDashboard from "./pages/admin-dashboard";
import LoginAuthentication from "./pages/login-authentication";
import EmployeeProfile from "./pages/employee-profile";
import SignUp from "./pages/signup";
import PayrollManagement from './pages/payroll-management';
import SalarySlipGenerator from './pages/salary-slip-generator';
import CompanySettings from './pages/company-settings';

function AppRoutes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LoginAuthentication />} />
          <Route path="/login-authentication" element={<LoginAuthentication />} />
          <Route path="/signup" element={<SignUp />} />
          
          {/* Protected Routes */}
          <Route path="/employee-dashboard" element={
            <ProtectedRoute allowedRoles={['employee', 'supervisor']}>
              <EmployeeDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/admin-dashboard" element={
            <ProtectedRoute allowedRoles={['admin', 'hr_manager']}>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/attendance-tracking" element={
            <ProtectedRoute>
              <AttendanceTracking />
            </ProtectedRoute>
          } />
          
          <Route path="/leave-management" element={
            <ProtectedRoute>
              <LeaveManagement />
            </ProtectedRoute>
          } />
          
          <Route path="/employee-profile" element={
            <ProtectedRoute>
              <EmployeeProfile />
            </ProtectedRoute>
          } />
          
          <Route path="/payroll-management" element={<ProtectedRoute><PayrollManagement /></ProtectedRoute>} />
          <Route path="/salary-slip-generator" element={<ProtectedRoute><SalarySlipGenerator /></ProtectedRoute>} />
          <Route path="/company-settings" element={<ProtectedRoute><CompanySettings /></ProtectedRoute>} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default AppRoutes;